export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "no_results_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sorry, no matches found"])}
      },
      "fr": {
        "no_results_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désolé, aucune correspondance n'a été trouvée"])}
      }
    }
  })
}